import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Text, View } from '@olxbr/design-system'
import { checkStrength } from '../../../util/validators'
import StrengthMeter from '../../molecules/StrengthMeter'
import PasswordInput from '../../molecules/PasswordInput'
import ErrorMsg from '../../atoms/ErrorMsg'
import { PasswordRules } from '../../molecules/PasswordRules'

const CAPTION_MESSAGE_DEFAULT = 'Crie uma senha forte para proteger a sua conta.'

const strengthLevelColors = {
  '-3': '#ff4444',
  '-2': '#ff4444',
  '-1': '#ff4444',
  0: '#ff4444',
  1: '#ff4444',
  2: '#ee9e1a',
  3: '#75c232',
  4: '#008348',
}

const Content = styled(View)`
  display: flex;
  flex-direction: column;
  margin-bottom: var(--spacing-3);
`

const InputWrapper = styled(View)`
  margin-top: 8px;
  margin-right: 0;
  margin-bottom: 8px;
  margin-left: 0;
`

const MessageTipRow = styled(View)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

const Message = styled(ErrorMsg)`
  width: 100%;
  color: ${props => strengthLevelColors[props.level]};
  margin-top: 8px;
`

const TipMessage = styled(Text)`
  width: 100%;
  font-size: 12px;
  margin-top: 8px;
  text-align: right;
`

const PasswordWithStrengthMeter = props => {
  const {
    level,
    label,
    message,
    caption,
    tipAlignment,
    value,
    onChange,
    onBlur,
    hasError,
    inputRef,
    onSubmitEditing,
    abTests,
    ...otherProps
  } = props
  const [captionMessage, setCaptionMessage] = useState(CAPTION_MESSAGE_DEFAULT)
  const [isRequiredFieldError, setIsRequiredFieldError] = useState(false)

  const eventHandler = handler => event => {
    const { value } = event.target
    const { strength, message } = checkStrength(value)
    if (handler) {
      setCaptionMessage(message)
      handler(value, strength, message)
    }
  }

  const handleFocus = () => setIsRequiredFieldError(true)

  return (
    <Content>
      <InputWrapper>
        <PasswordInput
          label={label}
          caption={captionMessage}
          aria-label="senha"
          hasError={hasError}
          onChange={eventHandler(onChange)}
          onBlur={eventHandler(onBlur)}
          onFocus={handleFocus}
          value={value}
          inputRef={inputRef}
          onSubmitEditing={onSubmitEditing}
          errorMsg={!value.length ? captionMessage : ''}
          {...otherProps}
        />
      </InputWrapper>

      <StrengthMeter level={level} />
      <PasswordRules value={value} isRequiredFieldError={isRequiredFieldError} />
    </Content>
  )
}

PasswordWithStrengthMeter.defaultProps = {
  hasError: false,
  tipAlignment: 'left',
}

PasswordWithStrengthMeter.propTypes = {
  level: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  tip: PropTypes.string,
  tipAlignment: PropTypes.string,
  hasError: PropTypes.bool,
  message: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.string,
  onSubmitEditing: PropTypes.func,
  inputRef: PropTypes.func,
  caption: PropTypes.string,
  abTests: PropTypes.string,
}

export default PasswordWithStrengthMeter
